import { Box, darken, List, ListItem, Typography } from '@mui/material';
import { LabeledValue } from '~/components/Fields/LabeledValue';
import { DoseMatrix } from '~/domain/patient/doseMatrix';

type DoseConfirmationProps = {
    selectedDoses: DoseMatrix[];
};

export default function DoseConfirmation({
    selectedDoses,
}: DoseConfirmationProps) {
    return (
        <Box display="grid" gap={2}>
            <Box>
                <Typography fontSize={14} gutterBottom>
                    The following must be acknowledged when exporting dose:
                </Typography>
                <List sx={{ pl: 2, listStyleType: 'disc', fontSize: 13 }}>
                    <ListItem sx={{ display: 'list-item', py: 0.2 }}>
                        Please be aware that the DICOM export does not reflect
                        any dose scaling operations performed in the workspace.
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', py: 0.2 }}>
                        The exported dose values will correspond to the
                        original, unmodified dose distribution
                    </ListItem>
                </List>
            </Box>

            <Box display="grid" gap={1}>
                {selectedDoses.map((dose) => (
                    <Box
                        key={dose.dicomUid}
                        display="grid"
                        px={2}
                        py={1}
                        gap={1}
                        bgcolor={(theme) =>
                            darken(theme.palette.background.paper, 0.1)
                        }
                        borderRadius={1}
                        border="1px solid"
                        borderColor={(theme) =>
                            darken(theme.palette.background.paper, 0.4)
                        }
                    >
                        <Box display="grid" gridTemplateColumns="1fr 1fr 1fr">
                            <LabeledValue
                                label="Name"
                                value={dose.plan?.label}
                            />
                            <LabeledValue
                                label="Summation type"
                                value={dose.doseSummationType}
                            />

                            <LabeledValue
                                label="Dose max"
                                value={
                                    dose.doseMaxGy.toFixed(1) + dose.doseUnits
                                }
                            />
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
